<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" size="mini" :inline="false">
            <el-form-item class="form-title" prop="i_pid" label="机构ID" style="width: 350px"  v-if="formData.i_id">
                <div class="mrA">{{formData.i_id}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_name" label="机构名称" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_name" size="mini" placeholder="请输入"></el-input>
                <div class="mrA" v-else>{{formData.vc_name}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_sname" label="机构简称" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_sname" size="mini" placeholder="请输入"></el-input>
                <div class="mrA" v-else>{{formData.vc_sname}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_pname" label="父机构名称" style="width: 350px" >
                <div class="mrA" >{{formData.vc_pname}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_pid" label="父机构ID" style="width: 350px" >
                <div class="mrA" >{{formData.i_pid}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_gsid" label="公司" style="width: 350px" required>
                <el-select v-if="canEdit" v-model="formData.i_gsid" filterable  size="mini"
                            clearable :remote="true" :remote-method="jtgssearch"style="margin-right: 9px;width:110px; " >
                    <el-option v-for="item in gsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <div class="mrA" v-else>{{formData.vc_gsname}}</div>
            </el-form-item>
            <el-form-item prop="i_iscj" label="是否车间" style="width: 350px">
                <el-radio-group v-model="formData.i_iscj" v-if="canEdit">
                    <el-radio  :label="1">是</el-radio>
                    <el-radio  :label="0">否</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.i_iscj==1?'是':'否'}}</div>
            </el-form-item>
            <el-form-item prop="i_isuse" label="是否启用" style="width: 350px" v-if="data.type=='edit'">
                <el-radio-group v-model="formData.i_isuse" v-if="canEdit">
                    <el-radio  :label="1">是</el-radio>
                    <el-radio  :label="0">否</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.i_isuse==1?'是':'否'}}</div>
            </el-form-item>
            <el-form-item label="用友code:" class="w50"  prop="vc_code_yongyou" >
                <span style="margin-right: 3px">{{formData.vc_code_yongyou}}</span>
                <el-button v-if="formData.i_id!=0&&canEdit" type="text" @click="tosync('用友')">同步</el-button>
            </el-form-item>
            <el-form-item label="南北code:" class="w50"  prop="vc_code_nanbei">
                <span style="margin-right: 3px">{{formData.vc_code_nanbei}}</span>
                <el-button v-if="formData.i_id!=0&&canEdit" type="text" @click="tosync('南北')">同步</el-button>
            </el-form-item>
            <el-form-item class="form-title" prop="i_order" label="排序号" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.i_order" size="mini" placeholder="请输入"></el-input>
                <div class="mrA" v-else>{{formData.i_order}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_lruname" label="录入人" style="width: 350px" >
                <div class="mrA" >{{formData.vc_lruname}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="dt_createtime" label="录入时间" style="width: 350px" >
                <div class="mrA" >{{formData.dt_createtime}}</div>
            </el-form-item>
        </el-form>
        <div  class="center">
            <el-button type="primary" @click="save('formData')" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">{{$t('button_save')}}</el-button>
            <!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">作废</el-button>-->
            <!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">启用</el-button>-->
            <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>
            <!--                <el-button type="warning" @click="flowSub" :disabled="disabled" size="small" v-if="canEdit">提交审批</el-button>-->
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props: {
            data:{
                type:Object,
                required: true,
                // default:()=>({})
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                formData:{
                    vc_name:'',
                    i_isuse:1,
                    i_iscj:0,
                    i_gsid:'',
                    vc_gsname:'',
                    vc_code_yongyou:'',
                    vc_code_nanbei:'',
                },
                canEdit:false,
                disabled:false,
                gsList:[],
                rules:{
                    vc_name:[{required: true,message:'机构名称不能为空'}],
                    // i_isuse:[{required: true,message:'是否启用不能为空'}],
                }
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
            //data:{
            //     handler(){
            //         if(this.data.i_id==0){
            //             this.canEdit=true
            //             this.getbzlist();
            //             this.getCompanyList();
            //             this.now=this.$DateTime.now();
            //             this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
            //             this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
            //             this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            //         }else{
            //             this.formData=JSON.parse(JSON.stringify(this.data))
            //         }
            //         console.log(this.data,'handler',this.formData)
            //
            //     },
            //     immediate:true,
            //     deep:true
            // },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.now=this.$DateTime.now();
            this.$nextTick(() => {
                this.onResize();
            });
            if(this.data.type=='add'){
                this.getCompanyList();
                this.canEdit=true;
                this.formData.i_id=0;
                this.formData.i_isuse=1;
                this.formData.i_iscj=0;
                this.formData.i_gsid=this.data.data.i_gsid;
                this.formData.vc_gsname=this.data.data.vc_gsname;
                this.formData.vc_pname=this.data.data.vc_name;
                this.formData.i_pid=this.data.data.i_id;
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid

            }else{
                this.formData=JSON.parse(JSON.stringify(this.data.data))
            }
            // this.formData=JSON.parse(JSON.stringify(this.data));
            // console.log(this.data,'mounted',this.formData)


        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            tosync(text){
                this.$confirm('是否同步到'+text+'系统','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消',
                    type:"warning"
                }).then(()=>{
                    console.log(this.formData,"this.formData")
                    this.updatesystem(text);
                }).catch(()=>{
                    this.$message.info('取消操作')
                })
            },
            async updatesystem(text){
                let param={
                    i_id:this.formData.i_id,
                },res={};
                if(text=='用友'){
                    res=await API.saveOrUpdateDepartment(param);
                }
                if(text=='南北'){
                    res=await API.saveSNDepartment(param);
                }
                if ( res.code == 1 ){
                    if(res.data){
                        if(text=='用友'){
                            this.formData.vc_code_yongyou=res.data;
                        }
                        if(text=='南北'){
                            this.formData.vc_code_nanbei=res.data;
                        }
                        this.$message.success(res.message);
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            cancel(){
                this.$emit('close')
            },
            save(formName){
                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        if(this.data.type=='add'){
                            this.addDept()

                        }else{
                            this.editDept()
                        }
                    }else{
                        return false
                    }
                })
            },
            editForm(){
                this.canEdit=true
                this.getCompanyList()

            },
            jtgssearch(val){
                this.gs_search=val;
                this.getCompanyList();
            },
            async getCompanyList(){
                let param={
                    isuse:1,
                    vc_search:this.gs_search,
                    pageSize: 20,
                    currentPage:1,
                    i_pid:0
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.gsList=res.data.companyList;
                    this.total=res.data.total;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //新增
            async addDept(){
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                let param=this.formData;
                let res=await API.addDept(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.canEdit=false
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.canEdit=false
                }
            },

            //编辑
            async editDept(){
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                let param=this.formData;
                let res=await API.editDept(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.canEdit=false
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.canEdit=false
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .center{
        text-align: center;
    }
    /deep/{
        .el-form-item__content{
            width: calc(100% - 145px);
        }
        .el-select{
            margin-right: 0 !important;
            width: 100% !important;
        }
    }

</style>